import React from 'react'
import { func, string, bool } from 'prop-types'
import classnames from 'classnames'
import svgs from './icons'

const Icon = ({ onClick, svg, isSelected, withoutHover, withoutFill, withoutEvents }) => {
  const addClasses = classnames({
    'svg-icon': true,
    'svg-icon--selected': isSelected,
    'svg-icon--no-hover': withoutHover,
    [`svg-icon--${svg}`]: svg,
    'svg-icon--without-fill': withoutFill,
    'svg-icon--without-events': withoutEvents
  })
  return svgs[svg]
    ? (
      <svg viewBox={svgs[svg].viewBox}
        className={addClasses}
        onClick={isSelected ? undefined : onClick}
        xmlns='http://www.w3.org/2000/svg'
      >
        {svgs[svg].svg}
      </svg>
    )
    : null
}

Icon.propTypes = {
  onClick: func,
  svg: string,
  isSelected: bool,
  withoutFill: bool,
  withoutHover: bool,
  withoutEvents: bool
}

export default React.memo(Icon)